export enum TagType {
  None = 0,
  Soft = 1,
  ContentThemes = 2,
  Markets = 3,
  InvestmentProducts = 4,
}
